(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["variant-main-picker"] && !Shopify.designMode) return;
  try {
    class SpectraliftConditionToggle extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.handleChange);
    }

    handleChange = (event) => {
      if (!(event.target instanceof HTMLInputElement)) return;
      if (!event.target.classList.contains('spectralift-condition-toggle__input')) return;

      event.stopPropagation();

      const optionId = event.target.checked
        ? this.dataset.outletOptionId
        : this.dataset.standardOptionId;
      const picker = this.closest('variant-picker');
      const option = picker?.querySelector(`[data-option-value-id="${optionId}"]`);

      if (!(option instanceof HTMLInputElement)) {
        event.target.checked = !event.target.checked;
        return;
      }

      option.click();
    };
  }

  if (!customElements.get('spectralift-condition-toggle')) {
    customElements.define('spectralift-condition-toggle', SpectraliftConditionToggle);
  }
  } catch(e) { console.error(e); }
})();

})();
